/*
 * tt-color-dots.js — clicking a colourway dot swaps the image, with a fade.
 *
 * Replaces assets/tt-product-card.js. Same delegation, wider reach: the
 * homepage's "choose your continent" cards are hand-written markup in
 * sections/tt-home-mock.liquid, not product cards, and Josh asked for the same
 * behaviour on both. So the contract is markup, not a section:
 *
 *     a container with [data-dots-target]  — the <img> to swap lives inside it
 *     buttons with     [data-swatch]       — each carrying data-full
 *     optionally       [data-card-link]    — an <a> to retarget at the variant
 *
 * A product card satisfies it, and so does a homepage card.
 *
 * DELEGATED FROM THE DOCUMENT, not bound per card. Three sections render product
 * cards, pagination replaces a grid wholesale, and Dawn's section rendering can
 * swap one in without a page load — a per-card listener would survive none of
 * that.
 *
 * PROGRESSIVE. The dots are <button>s that do nothing without this file, and the
 * card's own href is always a working link to the product.
 */
(function () {
  'use strict';

  /* Several sections load this file and the homepage can carry more than one
     product row, so the same tag can appear several times on one page. The
     browser fetches once but EXECUTES once per tag, which would bind the
     listener twice and toggle each dot straight back off. */
  if (window.__ttColorDots) return;
  window.__ttColorDots = true;

  var FADE = 'tt-dot-fade';

  /* Swapping `src` alone is not enough: image_tag emits a srcset, and the
     browser goes on honouring the old srcset over the new src. */
  function swap(img, url) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    /* Restart the animation. Removing the class is not enough on its own —
       the browser coalesces the remove and the re-add into no change at all
       unless something forces layout between them. */
    img.classList.remove(FADE);
    void img.offsetWidth;
    img.classList.add(FADE);
    /* And take it off again once the fade is over. The hover picture is hidden
       while this class is on (tt-product-row.css), so a class left behind killed
       the card's hover for good after one dot click - on both stores, until
       2026-10-19. The timeout covers reduced motion, where no animation runs and
       no animationend fires. */
    setTimeout(function () { img.classList.remove(FADE); }, 600);
  }

  /* Fade only once the new photograph is decoded. Dipping to 0.25 and back over
     an image that has not arrived shows the OLD one fading for no reason, then
     a hard cut — which is worse than no animation. The timeout is the safety
     net: a photograph that never loads must not leave the dot looking dead. */
  function preloadThenSwap(img, url) {
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      swap(img, url);
    };
    var probe = new Image();
    probe.onload = go;
    probe.onerror = go;
    probe.src = url;
    if (probe.complete) go();
    setTimeout(go, 1200);
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-swatch]');
    if (!dot) return;

    var scope = dot.closest('[data-dots-target]');
    if (!scope) return;

    event.preventDefault();

    var row = dot.parentElement;
    row.querySelectorAll('[data-swatch]').forEach(function (other) {
      var on = other === dot;
      other.classList.toggle('is-on', on);
      other.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    /* [data-dots-image] is the explicit hook, used by the hand-written homepage
       cards. The product card's <img> is built by `image_tag`, so it is found by
       class instead rather than threading a hyphenated data- argument through a
       filter.

       There used to be a second, absolutely-placed hover image to exclude here,
       and an `is-swatched` class set on the media box to stop it cross-fading
       away the finish the shopper had just chosen. The card renders one image as
       of 2026-08-18, so both are gone rather than left behind pointing at a
       class nothing sets. */
    var img = scope.querySelector('[data-dots-image]')
      || scope.querySelector('.tt-card__img')
      || scope.querySelector('img');
    if (img && dot.dataset.full) preloadThenSwap(img, dot.dataset.full);

    /* A boat card hovers to the same colour with the drive fitted
       (snippets/tt-drive-hover.liquid), so the hover picture follows the dot.
       Only dots that carry one touch it; every other card is as before. */
    var hover = scope.querySelector('.tt-card__img--hover');
    if (hover && dot.dataset.hover) hover.setAttribute('src', dot.dataset.hover);

    var link = scope.querySelector('[data-card-link]');
    if (link && dot.dataset.variant) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('variant', dot.dataset.variant);
      link.setAttribute('href', url.pathname + url.search);
    }
  });
})();
